import { INSERT, SELECT } from "@/utils/database_module"
import { OrderStatus } from "@/utils/types"

const ordersStatuses = {
    getAll : async () => {
        const order_statuses = await SELECT("order_status" ,  {order: "id ASC"}) as OrderStatus[]
        return order_statuses
    },

    insert : async (status : any) => {
        return await INSERT("order_status" ,status)
    },

    getOne : async (id : number) => {
        const order_statuses = await SELECT("order_status" , { conditions : [{column : "id" , operator : "=" , value : id}] , }) as any[]
        return order_statuses[0]
    },


}

export default ordersStatuses